// extracted by mini-css-extract-plugin
export var content = "_po-1";
export var noScroll = "_po-3";
export var paper = "_po-0";
export var scrollable = "_po-2";